import * as z from "zod";
import { gql } from "graphql-request";
import { ImageSchema, ImageFragment } from "../image";
import { SysSchema, SysFragment } from "../sys";
import { UnifiedButtonSchema, UnifiedButtonFragment } from "../unifiedButton";

export const LocalizedHeroSchema = z.object({
  __typename: z.literal("LocalizedHero"),
  sys: SysSchema,
  image: ImageSchema.nullable(),
  imageEn: ImageSchema.nullable(),
  buttonsCollection: z
    .object({
      items: z.array(UnifiedButtonSchema).nullish(),
    })
    .nullish(),
});

export const LocalizedHero = LocalizedHeroSchema;
export type LocalizedHero = z.infer<typeof LocalizedHeroSchema>;

export const LocalizedHeroFragment = gql`
  fragment LocalizedHeroFragment on LocalizedHero {
    __typename
    sys {
      ...SysFragment
    }
    image {
      ...ImageFragment
    }
    imageEn: image(locale: "en") {
      ...ImageFragment
    }
    buttonsCollection {
      items {
        __typename
        ... on UnifiedButton {
          ...UnifiedButtonFragment
        }
      }
    }
  }
  ${SysFragment}
  ${ImageFragment}
  ${UnifiedButtonFragment}
`;
